import InfiniteScrollLoadMore from './InfiniteScrollLoadMore';

export { type InfiniteScrollLoadMoreProps } from './InfiniteScrollLoadMore';
export default InfiniteScrollLoadMore;
